import { Injectable } from '@angular/core';
import { Checkpoint } from 'app/models2/localization/checkpoint';

@Injectable({
  providedIn: 'root',
})
export class CheckpointService {
  constructor() {}

  assignButtonTypeToLastComplete(controlPointer: Checkpoint[]): void {
    let lastCompleteIndex = -1;

    for (let i = 0; i < controlPointer.length; i++) {
      if (controlPointer[i].complete) {
        lastCompleteIndex = i;
      }
    }

    if (lastCompleteIndex !== -1) {
      // Eliminar buttonsType = [3] de los elementos antes del último con complete = true
      for (let i = 0; i < lastCompleteIndex; i++) {
        const buttonsType = controlPointer[i].buttonsType || [];
        const index = buttonsType.indexOf(3);
        if (index !== -1) {
          buttonsType.splice(index, 1);
        }
      }

      // Asignar buttonsType = [3] al último con complete = true si no lo tiene ya
      if (lastCompleteIndex !== -1 && lastCompleteIndex !== 0) {
        const lastButtonsType =
          controlPointer[lastCompleteIndex].buttonsType || [];
        if (!lastButtonsType.includes(3)) {
          lastButtonsType.push(3);
        }
        controlPointer[lastCompleteIndex].buttonsType = lastButtonsType;
      }
    }
  }
}
